import { animate, state, style, transition, trigger } from '@angular/animations';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ShipyardService } from 'src/app/modules/shipyard/shipyard.service';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HeaderService } from '../header/header.service';
import { GridActionsService } from 'src/app/data-grid/grid-actions.service';
import { LoginModel } from 'src/app/models/login.model';
import { UpgradeFeemiumDialogComponent } from 'src/app/modules/shipyard/upgrade-feemium-dialog/upgrade-feemium-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CreateShipmentPopupComponent } from '../create-shipment-popup/create-shipment-popup.component';
import { CreateShipmentConfirmDialogComponent } from '../create-shipment-confirm-dialog/create-shipment-confirm-dialog.component';

@Component({
  selector: 'app-plan-added',
  templateUrl: './plan-added.component.html',
  styleUrls: ['./plan-added.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class PlanAddedComponent extends DataSource<any> implements  OnChanges,OnDestroy {
 _shipmentPlanPreview:any;
 private destroy$ = new Subject<void>();
 dataSource;

 get shipmentPlanPreview() {
  return this._shipmentPlanPreview;
}
@Input() set shipmentPlanPreview(value) {
  this._shipmentPlanPreview = value;
}
@Input() account;
@Input() isCaseQty;
@Input() userInfo:LoginModel;
@Output() startProgress: EventEmitter<any> = new EventEmitter();
@Output() resetPlan: EventEmitter<any> = new EventEmitter();
@Input() searchWarehouseId;
@Input() exactMatch;
@Input() skusToAddToShipment;
@Input() selectedAddress;
@Input() selectedTargetFC;
displayedColumns = ['destinationId','skuCount', 'Qty', 'shipTo', 'pctMatch','millage','shipmentHeaderId','export','create'];
isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('detailRow');
_onChange;

get onChange() {
  return this._onChange;
}
@Input() set onChange(value) {
  this._onChange = value;
}
  
  constructor(
    public shipyardService:ShipyardService,
    private snackBar:MatSnackBar,
    private headerService:HeaderService,
    private gridActionService: GridActionsService,
    private dialog:MatDialog
    ) { 
    super()

    this.headerService.remoteActionBroadcaster.pipe(filter((e) => e.action === "ConfirmShipmentPlan"),takeUntil(this.destroy$)).subscribe((e) => {
      const createShipIdx = this.shipyardService.createShipment?.findIndex((res) => res.id == e.id);
      const createShipPlan = this.shipyardService.createShipment?.filter((res) => res.id == e.id);

      if(e?.response?.data || e.response.responseType === "error"){        
        if(createShipIdx !== -1 && this.shipyardService.createShipment[createShipIdx].isSubPlan){
          this.shipyardService.loadCreateShipment = false;          
          this.shipmentPlanPreview[createShipPlan[0].index].loading = false;  
          this.shipyardService.createShipment.splice(createShipIdx, 1);
          if (e?.response?.data) {
            const result=e?.response?.data;
            result?.forEach((res)=>{
              this.createShipmentRenderer(res,createShipPlan[0]);
            })
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.shipyardService.loadCreateShipment=false;
    this.shipmentPlanPreview=[];
    this.destroy$.next();
    this.destroy$.unsubscribe(); 
  }

  createShipmentRenderer(e, createShipPlan){
    this.shipyardService.ShipIdChange = null; 
  if(e.isSuccess && e.isSynced){    
    this.shipmentPlanPreview[createShipPlan.index].planCreated = true;
    this.shipmentPlanPreview[createShipPlan.index].shipmentHeaderId = Number(e.shipmentHeaderId);
    this.shipmentPlanPreview[createShipPlan.index].shipmentId = e.shipmentId; 
    this.assignFreemium(Number(e.shipmentHeaderId));
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 3000,
      horizontalPosition: "center",
      data: {
        title: "Shipments has been created successfully",
        action: "Dismiss",
        type: "success",
      },
    });
  } else if(!e.isSuccess && !e.isSynced){    
    this.shipmentPlanPreview[createShipPlan.index].loading = false;  
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 3000,
      horizontalPosition: "center",
      data: {
        title: (e.isSuccess && !e.isSynced) ? e.syncErrorMessage : e.errorMessage,
        action: "Dismiss",
        type: (e.isSuccess && !e.isSynced) ? "info" : "error", 
      },
    });
  }
  }  

  assignFreemium(shipmentHeaderId){
    if(this.userInfo.isShipyard === 1 && this.userInfo.freemiumAvail){
      this.shipyardService.AssignFreemium(shipmentHeaderId).pipe(takeUntil(this.destroy$)).subscribe((res)=>{
        this.shipyardService.updateLocalStorageKey(
          "freemiumAvail",
          res
        );
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.shipmentPlanPreview && this.shipmentPlanPreview.length !== 0){
      this.dataSource = this.connect();
      this.shipmentPlanPreview.forEach((res)=>{  
       // res.skus.sort((a,b) => a.sku?.localeCompare(b.sku));
       res.skus.sort((a, b) => {
        if (a.isQtyLocked !== b.isQtyLocked) {
          return a.isQtyLocked ? -1 : 1; 
        }
        return a.pctMatch - b.pctMatch; 
      });
        res.Qty = res.skus.reduce((prev,next)=>prev+next.qty,0);
        res.skuCount = res.skus?.filter(el => el.qty > 0).length;
      });
    }
  }

  connect(): Observable<any[]> {
    const rows = [];
    if(this.shipmentPlanPreview && this.shipmentPlanPreview.length !== 0){
      this.shipmentPlanPreview?.forEach((element:any) => {       
        element.isExpend=false;
        rows.push(element, { detailRow: true, element })
      });
    }  
     return of(rows);
  }

  disconnect(collectionViewer: CollectionViewer): void {    
  }

  toggleRow(element) {
    this.shipmentPlanPreview?.forEach((res:any,i) => {
      if(res.shipmentId == element.shipmentId){
        res.expanded=!element.expanded
      }     
    });
  }

  restrictSpecialChar(event) {
    let k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k == 32) || (k >= 39 && k <= 57));
  }

  create(shipment){
    if(this.headerService.isNewFlow){
      this.dialog
      .open(CreateShipmentPopupComponent, {
        hasBackdrop: false,
        width: "700px",
        data:shipment
      })
      .afterClosed()
      .subscribe(() => {
      });
    } else{
      this.createOldFlow(shipment)
    }   
  }

  createOldFlow(shipment){
    if (this.userInfo.isShipyard === 2 || this.userInfo.freemiumAvail) {
        this.createShipment(shipment);
    }else{
      this.upgradeToPremium(shipment);
    }
  }
  
  createShipment(shipment){
    this.dialog
    .open(CreateShipmentConfirmDialogComponent, {
      width: "400px",
      data:{
        title: "Create Shipment",
        shipment
      }
    })
    .afterClosed()
    .pipe(filter((e) => e === "Confirm"))
    .subscribe(() => {
    this.shipyardService.loadCreateShipment = true;
    let selectedPlanIdx = this.shipmentPlanPreview.findIndex((item)=>shipment.shipmentId == item.shipmentId);
    this.shipmentPlanPreview[selectedPlanIdx].loading = true;
    const skus = {
      shipmentPlanHeaderId: shipment.shipmentPlanHeaderId,
      shipmentId: shipment.shipmentId,
      shipmentName: shipment.shipmentName,
      isOriginal: false      
    };
    
    const confirmShipmentSpPayload={
      shipmentPlanRequests:[skus]
    }
    this.shipyardService
    .ConfirmShipmentSp(confirmShipmentSpPayload)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
        next: (e:any) => {
      this.shipyardService.planProcess=[];
      this.shipyardService.planProcessWithDestination=[];
      this.resetPlan.emit();
        if(e){
            this.shipyardService.createShipment.push({
            id:e.id,
            index: selectedPlanIdx,
            shipmentPlan: this.shipmentPlanPreview,
            isSubPlan:true
           });          
        }  
      },
       error: (err) => {
        this.shipyardService.loadCreateShipment = false;
        this.shipmentPlanPreview[selectedPlanIdx].loading = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: err?.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
       }
     });
    }
    )
  }

  planAllAdded(shipment){
    let selectedPlanIdx = this.shipmentPlanPreview.findIndex((item)=>shipment.destinationId == item.destinationId);
      if(selectedPlanIdx !== -1) 
      {
        this.shipmentPlanPreview[selectedPlanIdx].loader = true;
        this.shipmentPlanPreview[selectedPlanIdx].disable = true;
      }
      const payload:any = {
       shipmentId: shipment.shipmentId,
       account:this.account[0],
       //destinationOnly:true,
       AddQty: false,
       searchWareHouseId:this.searchWarehouseId,
       ExactMatch :this.exactMatch
      }
      if(this.skusToAddToShipment.FbaType !== 'All'){
        payload.shipmentType = this.shipyardService.getShipmentTypeId(this.skusToAddToShipment.FbaType)
      }
      if(this.selectedTargetFC && this.selectedAddress){
        payload.targetFulfillmentCenterId=this.selectedTargetFC.fulfillmentCenterId
        payload.fromAddress={
          add1: this.selectedAddress.add1,
          city: this.selectedAddress.city,
          state: this.selectedAddress.state,
          zip: this.selectedAddress.zip,
          country: this.selectedAddress.country
        }
      }
     this.shipyardService.PlanAddAllHere(payload).pipe(takeUntil(this.destroy$)).subscribe({
         next: (res:any) => {
          if(res){
            this.startProgress.next(null);
           this.shipyardService.planProcessWithDestination.push(
             {
                 id:res.id,
                 shipmentId:shipment.shipmentId,
                 destinationId: shipment.destinationId
             });
         }
     },
      error: (err) => {
       const index= this.shipmentPlanPreview.findIndex(res=> res.destinationId == shipment.destinationId);
       if(index != -1){
         this.shipmentPlanPreview[index].disable= false;
         this.shipmentPlanPreview[index].loader = false;
       }
      }
     });
     }

     exportShipment(element){
      this.shipyardService.exportShipmentPlan(element.shipmentId).pipe(takeUntil(this.destroy$)).subscribe({
       next: (e) => {
            this.gridActionService.downloadBlob(
              e.body,
              null,
              ('Planshipment') + ".csv"
            );
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 3000,
              horizontalPosition: "center",
              data: {
                title: 'Shipment Plan has been Exported Successfully',
                action: "Dismiss",
                type: "success",
              },
            });
           },
      error: (err) => {
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: "center",
                data: {
                  title: err.error.error[0],
                  action: "Dismiss",
                  type: "error",
                },
              }
            );
      }
      });
    }
    upgradeToPremium(shipment) {
      this.dialog
        .open(UpgradeFeemiumDialogComponent, {
          width: "500px",
        })
        .afterClosed()
        .pipe(filter((e) => e === "Continue"))
        .subscribe(() => {
          this.createShipment(shipment);
        });
    }
    
  copy(e,element) {
    element.copied = true;
    setTimeout(() => {
      element.copied = false;
    }, 800);
  }


  round(a){
    return Math.floor(a)
  }
}
  
